(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ak-2ND-shopping-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ak-shopping-hub')) {
  customElements.define('ak-shopping-hub', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.timers = [];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.editor = !!window.Shopify?.designMode;
      this.groups = [];
      const listen = (el, type, fn) => el.addEventListener(type, fn, {signal});
      const horizontal = (track, prev, next, step) => {
        const rtl = getComputedStyle(track).direction === 'rtl';
        const position = () => Math.abs(track.scrollLeft);
        const max = () => Math.max(0, track.scrollWidth - track.clientWidth);
        const move = (direction, wrap = false) => {
          let target = position() + direction * step();
          if (wrap && position() >= max() - 2) target = 0;
          track.scrollTo({left: (rtl ? -1 : 1) * Math.max(0, Math.min(max(), target)), behavior: this.motion.matches ? 'instant' : 'smooth'});
        };
        const update = () => {
          if (prev) prev.disabled = position() < 2;
          if (next) next.disabled = position() >= max() - 2;
        };
        if (prev) listen(prev, 'click', () => move(-1));
        if (next) listen(next, 'click', () => move(1));
        listen(track, 'scroll', update);
        this.resize.observe(track);
        this.updates.push(update);
        update();
        return move;
      };
      this.updates = [];
      this.resize = new ResizeObserver(() => this.updates.forEach(fn => fn()));
      const hub = this.querySelector('[data-hub-track]');
      horizontal(hub, this.querySelector('[data-hub-prev]'), this.querySelector('[data-hub-next]'), () => (hub.querySelector('.akh__block:not([hidden])')?.getBoundingClientRect().width || hub.clientWidth) + parseFloat(getComputedStyle(hub).gap || 0));
      // On mobile, swiping anywhere on a product tile or banner changes hub panels.
      // Inner auto-slide jobs still work; ordinary taps continue to open links.
      const mobileHub = matchMedia('(max-width: 749px)');
      let mobileSwipe = null;
      let suppressLinkClickUntil = 0;
      listen(hub, 'pointerdown', event => {
        if (!mobileHub.matches || this.dataset.mobile !== 'carousel' ||
            event.pointerType !== 'touch' || !event.isPrimary) return;
        const block = event.target.closest('.akh__block');
        if (!block) return;
        mobileSwipe = {id: event.pointerId, x: event.clientX, y: event.clientY, block};
      });
      listen(hub, 'pointerup', event => {
        if (!mobileSwipe || mobileSwipe.id !== event.pointerId) return;
        const swipe = mobileSwipe;
        mobileSwipe = null;
        if (!mobileHub.matches || this.dataset.mobile !== 'carousel') return;
        const dx = event.clientX - swipe.x;
        const dy = event.clientY - swipe.y;
        if (Math.abs(dx) < 35 || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
        const blocks = [...hub.querySelectorAll('.akh__block:not([hidden])')];
        const index = blocks.indexOf(swipe.block);
        const rtl = getComputedStyle(hub).direction === 'rtl';
        const delta = dx < 0 ? (rtl ? -1 : 1) : (rtl ? 1 : -1);
        const next = blocks[Math.max(0, Math.min(blocks.length - 1, index + delta))];
        if (next && next !== swipe.block) {
          next.scrollIntoView({behavior: this.motion.matches ? 'instant' : 'smooth',
            block: 'nearest', inline: 'start'});
          suppressLinkClickUntil = Date.now() + 450;
        }
      });
      listen(hub, 'pointercancel', () => { mobileSwipe = null; });
      // Do not accidentally follow product/banner links after a swipe.
      hub.addEventListener('click', event => {
        if (Date.now() < suppressLinkClickUntil && event.target.closest('a')) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, {signal, capture:true});
      this.querySelectorAll('.akh__block').forEach(block => {
        const group = {block, paused:false, hover:false, focus:false, touchUntil:0, visible:true, jobs:[]};
        const rawExpiry = (block.dataset.expires || '').trim();
        let normalized = rawExpiry.replace(' ', 'T');
        if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) normalized += 'T23:59:59';
        const simple = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?$/;
        if (simple.test(normalized)) normalized += block.dataset.timezone || '+04:00';
        const validFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(?:Z|[+-]\d{2}:\d{2})$/i.test(normalized);
        group.expiry = validFormat ? Date.parse(normalized) : NaN;
        const clockWrapper = block.querySelector('[data-clock-wrapper]');
        const error = block.querySelector('[data-expiry-error]');
        if (clockWrapper && !Number.isFinite(group.expiry)) {
          clockWrapper.hidden = !this.editor;
          if (error) error.hidden = false;
        }
        this.groups.push(group);
        listen(block, 'mouseenter', () => group.hover = matchMedia('(hover: hover)').matches);
        listen(block, 'mouseleave', () => group.hover = false);
        listen(block, 'focusin', () => group.focus = true);
        listen(block, 'focusout', e => group.focus = block.contains(e.relatedTarget));
        listen(block, 'pointerdown', () => group.touchUntil = Date.now() + 10000);
        listen(block, 'wheel', () => group.touchUntil = Date.now() + 10000);
        const tile = block.querySelector('[data-tile-track]');
        if (tile) {
          const move = horizontal(tile, block.querySelector('[data-tile-prev]'), block.querySelector('[data-tile-next]'), () => (tile.firstElementChild?.getBoundingClientRect().width || tile.clientWidth) + parseFloat(getComputedStyle(tile).columnGap || 0));
          if (tile.dataset.auto === 'true' && tile.children.length > 1) group.jobs.push({run:()=>move(1,true), interval:Math.max(1,Number(tile.dataset.interval)||4)*1000, last:Date.now()});
        }
        block.querySelectorAll('[data-banner]').forEach(banner => {
          const slides = banner.querySelector('[data-slides]');
          const move = horizontal(slides, banner.querySelector('[data-slide-prev]'), banner.querySelector('[data-slide-next]'), () => slides.clientWidth);
          if (slides.children.length > 1) group.jobs.push({run:()=>move(1,true), interval:Math.max(1,Number(banner.dataset.interval)||4)*1000, last:Date.now()});
        });
        const button = block.querySelector('[data-motion]');
        button.hidden = true;
        listen(button,'click',()=>{group.paused=!group.paused;button.setAttribute('aria-pressed',String(group.paused));button.textContent=group.paused?this.dataset.resume:this.dataset.pause;});
      });
      this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
        const group = this.groups.find(g=>g.block===entry.target);
        if(group) group.visible=entry.isIntersecting;
      }));
      this.groups.forEach(g=>this.observer.observe(g.block));
      const tick = () => {
        const now = Date.now();
        this.groups.forEach(g=>{
          const expiry = g.expiry;
          if (expiry > 0) {
            const remaining = Math.max(0,Math.ceil((expiry-now)/1000));
            const clock = g.block.querySelector('[data-countdown]');
            if(clock) clock.textContent = `${Math.floor(remaining/86400)}d ${String(Math.floor(remaining/3600)%24).padStart(2,'0')}:${String(Math.floor(remaining/60)%60).padStart(2,'0')}:${String(remaining%60).padStart(2,'0')}`;
            if(!this.editor) g.block.hidden = remaining === 0;
          }
          const stopped = document.hidden || this.motion.matches || !g.visible || g.paused || g.hover || g.focus || g.block.hidden || now < g.touchUntil;
          g.jobs.forEach(job=>{if(stopped) job.last=now;else if(now-job.last>=job.interval){job.run();job.last=now;}});
        });
        this.updates.forEach(fn=>fn());
      };
      tick();
      this.timers.push(setInterval(tick,250));
      listen(document,'shopify:block:select',e=>{const block=this.querySelector(`[id="akh-${e.detail.sectionId}-${e.detail.blockId}"]`);if(block) block.scrollIntoView({block:'nearest',inline:'nearest'});});
    }
    disconnectedCallback() {
      this.abort?.abort();this.abort=null;
      this.timers?.forEach(clearInterval);
      this.resize?.disconnect();this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ak-shopping-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
const init = root => {
 if(root.dataset.akhReady)return;root.dataset.akhReady='true';

 const mobile=matchMedia('(max-width: 749px)');
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const abort=new AbortController();
 const signal=abort.signal;
 const cleanups=[];
 const players=[];
 const refresh=()=>players.forEach(p=>p.schedule());
 mobile.addEventListener('change',refresh,{signal});
 reduced.addEventListener('change',refresh,{signal});
 document.addEventListener('visibilitychange',refresh,{signal});

 root.querySelectorAll('[data-akh-video-toggle]').forEach(button=>{
  const video=button.closest('.akh-card').querySelector('video');
  if(!video)return;
  video.controls=false;
  const sync=()=>{
   const paused=video.paused||video.ended;
   button.dataset.paused=String(paused);
   button.setAttribute('aria-label',paused?button.dataset.playLabel:button.dataset.pauseLabel);
  };
  button.addEventListener('click',event=>{
   event.preventDefault();
   event.stopPropagation();
   if(video.paused||video.ended){
    const play=video.play();
    if(play&&typeof play.catch==='function')play.catch(sync);
   }else video.pause();
   sync();
  },{signal});
  ['play','playing','pause','ended','emptied','error'].forEach(event=>video.addEventListener(event,sync,{signal}));
  sync();
 });
 const recent=root.querySelector('[data-akh-recent]');
 if(recent){try{const data=JSON.parse(localStorage.getItem(root.dataset.recentKey)||'[]');const item=data.find(x=>x&&typeof x.url==='string'&&/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(x.url)&&typeof x.image==='string'&&(/^(https:)?\/\//.test(x.image)));if(item){const a=recent.querySelector('a');a.href=item.url;a.setAttribute('aria-label',item.title||'');const img=recent.querySelector('img');img.src=item.image;img.alt=item.title||'';recent.hidden=false;}}catch(e){}}
 root.querySelectorAll('[data-akh-track]').forEach(track=>{
  const name=track.dataset.akhTrack;const prev=root.querySelector('[data-akh-prev="'+name+'"]');const next=root.querySelector('[data-akh-next="'+name+'"]');
  const cards=()=>Array.from(track.children).filter(c=>!c.hidden);const rtl=getComputedStyle(track).direction==='rtl';
  const update=()=>{const list=cards();const overflow=track.scrollWidth>track.clientWidth+2;if(prev)prev.parentElement.hidden=!overflow;const rect=track.getBoundingClientRect();if(prev)prev.disabled=!overflow||!list.length||(rtl?list[0].getBoundingClientRect().right<=rect.right+3:list[0].getBoundingClientRect().left>=rect.left-3);if(next)next.disabled=!overflow||!list.length||(rtl?list.at(-1).getBoundingClientRect().left>=rect.left-3:list.at(-1).getBoundingClientRect().right<=rect.right+3);};
  const move=dir=>{const first=cards()[0];if(!first)return;const gap=parseFloat(getComputedStyle(track).gap)||0;track.scrollBy({left:dir*(rtl?-1:1)*(first.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
  if(prev)prev.addEventListener('click',()=>move(-1));if(next)next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});const resize=new ResizeObserver(()=>{update();refresh();});resize.observe(track);cleanups.push(()=>resize.disconnect());update();

  const enabled=root.dataset[name==='large'?'mobileAutoLarge':'mobileAutoSmall']==='true';
  if(enabled){
   let timer=0,touching=false,inView=false,settle=0;
   const delay=Math.max(2000,(Number(root.dataset.mobileAutoDelay)||4)*1000);
   const available=()=>mobile.matches&&!reduced.matches&&cards().length>1&&track.scrollWidth>track.clientWidth+2;
   const canRun=()=>available()&&!touching&&inView&&!document.hidden&&!track.contains(document.activeElement)&&!root.contains(document.activeElement?.closest('video'));
   const schedule=()=>{clearTimeout(timer);if(canRun())timer=setTimeout(()=>{if(!canRun())return;const list=cards();const rect=track.getBoundingClientRect();const end=rtl?list.at(-1).getBoundingClientRect().left>=rect.left-3:list.at(-1).getBoundingClientRect().right<=rect.right+3;if(end)track.scrollTo({left:0,behavior:'smooth'});else move(1);schedule();},delay);};
   const start=()=>{touching=true;clearTimeout(timer);};
   const stop=()=>{touching=false;schedule();};
   track.addEventListener('pointerdown',start,{passive:true,signal});
   document.addEventListener('pointerup',stop,{passive:true,signal});
   document.addEventListener('pointercancel',stop,{passive:true,signal});
   track.addEventListener('focusin',()=>clearTimeout(timer),{signal});
   track.addEventListener('focusout',()=>{clearTimeout(settle);settle=setTimeout(schedule,0);},{signal});
   track.addEventListener('scroll',schedule,{passive:true,signal});
   const visibility=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;schedule();},{threshold:0.25});
   visibility.observe(track);
   players.push({schedule,available});
   cleanups.push(()=>{clearTimeout(timer);clearTimeout(settle);visibility.disconnect();});
  }
 });
 refresh();
 root.akhCleanup=()=>{abort.abort();cleanups.forEach(fn=>fn());delete root.dataset.akhReady;};
 if(matchMedia('(prefers-reduced-motion: reduce)').matches)root.querySelectorAll('video[autoplay]').forEach(v=>{v.autoplay=false;v.pause();v.controls=false;});
};
document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-akh]').forEach(root=>root.akhCleanup?.()));
document.querySelectorAll('[data-akh]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-akh]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
